import {useQuery} from "@apollo/client";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {useTable} from "@/lib/hooks/useTable.ts";
import {GQL_PRIVATE_LOCATIONS_LIST_QUERY, PrivateLocationsListResult} from "@/lib/queries/monitoring.ts";
import {PrivateLocationsControlBar} from "@/pages/monitoring/privatelocations/list/PrivateLocationsControlBar.tsx";
import {PrivateLocationsTable} from "@/pages/monitoring/privatelocations/list/PrivateLocationsTable.tsx";
import {getLocationStatus} from "@/pages/monitoring/privatelocations/list/utils.ts";

export const PrivateLocationsList = () => {
  const {user} = useCurrentUserContext();

  const {pagination, setPagination, sorting, sortingString, setSorting} = useTable();

  const {data, loading, previousData} = useQuery<PrivateLocationsListResult>(GQL_PRIVATE_LOCATIONS_LIST_QUERY, {
    variables: {
      ...pagination,
      sort: sortingString,
    },
  });

  const renderData = loading ? previousData : data;
  if (!renderData) {
    return <LoadingContainer />;
  }

  const privateLocationCount = renderData.privateLocations.total;
  const privateLocationLimit = user?.account.limit_private_locations ?? 0;
  const privateLocationsAvailable =
    privateLocationLimit - privateLocationCount >= 0 ? privateLocationLimit - privateLocationCount : 0;

  const extendedRenderDataItems = renderData.privateLocations.items.map((item) =>
    Object.assign({}, item, getLocationStatus(item))
  );

  return (
    <>
      <PrivateLocationsControlBar privateLocationsAvailable={privateLocationsAvailable} />
      <PrivateLocationsTable
        privateLocations={extendedRenderDataItems}
        privateLocationsAvailable={privateLocationsAvailable}
        loading={loading}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        pagination={pagination}
        updatePagination={setPagination}
        totalRows={renderData.privateLocations.total}
        paginationData={extendedRenderDataItems}
      />
    </>
  );
};
